import FontKeys from "./FontKeys";
import Game from "./scenes/Game";
import Intro from "./scenes/Intro";

export default {
    /**
     * Add your scene classes here. Simply put the scene class.
     * Ex: `scenes: [MyScene,MyOtherScene]`
     * @type {{KEY:string}[]}
     */
    scenes: [Intro, Game],

    /**
     * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
     * It is recommended you put `MyScene.KEY` here instead of using a string.
     * @type {string}
     */
    startScene: Intro.KEY,
    // startScene: Game.KEY,

    DESKTOP: false,
    TEXT_COLOR_1:"#82B531",
    TEXT_COLOR_2:"#0D8C5B",
    GAME_STATE: "intro", //"intro", "game"
    GAME_PAUSED: false,
    MUTE: false,
    GAME_DONE: false,
    GAME_LEVEL: 1,
    CORRECT_SOUNDS:["Firework_1", "Firework_2"],
    GAME_FONTS: [FontKeys._bebasregular, FontKeys._neuropolregular, FontKeys._droid_sansbold],
    INTRO_SOUNDS:["Three", "Two", "One", "BlastOff"],
    ROCKET_ARR: [],
    ROCKETPOS_ARR: [],
    FIREWORKS: ["firework", "fireworkOrange", "fireworkBlue"],
    GLITTER: ["fireworkGlitterGreen", "fireworkGlitter", "fireworkGlitterBlue"],
    SCORE: 0,
    SPEED: 10000,
    WORDS_MADE: 0,
    WORDS_MISSED: 0,
    WORD_BANK:["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M",
               "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"]
}
